import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class AssetsIcon extends BaseIcon {
  getChildren = () => [<path fill={ this.getColor() }
                             d="M7.9.26,4.25,4.14,5.06.26ZM11,.26l.83,3.88L8.19.26ZM11.64,5H4.41L8,1.08ZM3.39,5H.05L4.34.45Zm0,.67,3.27,8.63L0,5.63Zm.73,0h7.73L8,15.66ZM12.66,5,11.7.43,16,5ZM9.33,14.25,12.6,5.63H16Z"/>]
  getViewBox = () => '0 0 16 16'
}